module.exports = __webpack_public_path__ + "static/media/stop-1.fffb21fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/stop-1.svg
// module id = 1368
// module chunks = 0